import React from 'react';
import { UserManagement } from '@sf/shared';
import api from '../../services/api';

const usersApi = {
  list:                  ()        => api.get('/users').then((r) => r.data),
  create:                (data)    => api.post('/users', data).then((r) => r.data),
  toggleActive:          (id, val) => api.put(`/users/${id}`, { is_active: val }),
  toggleFinancialActive: (id, val) => api.put(`/users/${id}`, { financial_active: val }),
};

const userRolesApi = {
  list:   ()         => api.get('/fleet/user-roles').then((r) => r.data.data || r.data),
  create: (data)     => api.post('/fleet/user-roles', data),
  update: (id, data) => api.put(`/fleet/user-roles/${id}`, data),
  delete: (id)       => api.delete(`/fleet/user-roles/${id}`),
};

export default function UsersPage() {
  return <UserManagement usersApi={usersApi} userRolesApi={userRolesApi} />;
}
